<template>
  <div class="confirmation-dialog-container" v-if="show">
    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box"
         :style="{top:top+'px', left: left + 'px', right: right + 'px'}">
      <div class="dialog-content-without-cross">

        <weex-text
          class="font-size-sm-base"
          v-html="confirmationMessage"
        ></weex-text>

        <div class="item-row-alignment horizontal-center margin-top-20">
          <wxc-button
            :text="confirmText"
            :btnStyle="dialogActionButtonStyle"
            :textStyle="{ color: 'black' }"
            style="margin-left: 2px; margin-right: 2px"
            @wxcButtonClicked="onConfirm"
          ></wxc-button>

          <wxc-button
            :text="cancelText"
            :btnStyle="dialogActionButtonStyle"
            :textStyle="{ color: 'black' }"
            style="margin-left: 2px; margin-right: 2px"
            @wxcButtonClicked="onNotConfirm"
          ></wxc-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";

export default {
  components: { WxcOverlay, WxcButton },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    confirmationMessage: {
      type: String,
      default: "Are you sure?"
    },

    confirmText: {
      type: String,
      default: "Yes"
    },

    cancelText: {
      type: String,
      default: "No"
    },

    top: {
      type: Number,
      default: 20
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    }
  },

  computed: {
    dialogActionButtonStyle() {
      return {
        backgroundColor: "white",
        borderColor: "gray",
        borderWidth: "1px",
        borderStyle: "solid",
        width: "50%"
      };
    }
  },

  methods: {
    onConfirm() {
      this.$emit("onConfirm");
    },

    onNotConfirm() {
      this.$emit("onNotConfirm");
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.confirmation-dialog-container {
  position: absolute;
  z-index: 10000;
}
</style>
